import i18next from 'i18next';
import { INFO_PANE_PAGES } from '../../redux_store';

export const ASSESSMENTS_ALERTS_COLUMNS = [
  {
    size: 200,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'patientMrnNumber',
    disableSorting: true,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientFirstName'),
    accessorKey: 'firstName',
    disableSorting: true,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientLastName'),
    accessorKey: 'lastName',
    disableSorting: true,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:assessment'),
    accessorKey: 'surveyName',
    disableSorting: true,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:completedTimestamp'),
    accessorKey: 'completedDate',
    disableSorting: true,
    isDefaultCell: true,
  },
];

export const ANIMATION_TIMEOUT = 1500;
